export const SITE_URL: string =
  (import.meta.env.VITE_SITE_URL as string | undefined) || 'https://usfanslink.rest';

export const SITE_NAME = 'USFansLink';

export const FAVICON_URL =
  'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/2277e9ffbdee9fd651886f1aeeba0d56.jpeg';

export function absoluteUrl(path: string): string {
  return `${SITE_URL.replace(/\/+$/, '')}${path}`;
}